export default "/images/vendor/flag-icon-css/flags/1x1/la.svg?d2ebfb8712f5375ce406ca95b1255518";